import { useWorkflow } from '@/common/workflowEngine/useWorkflow';
import { crud } from '@/common/crud';
import { $httpFhirApi } from '@/common/api/httpFhir.service';

const addItem = async (data, existingTransaction = false) => {
    let transaction = existingTransaction || [];

    data.items.forEach((item) => {
        data.list.item.push(item);
    });
    transaction.push(crud.patch(data.list));

    if (existingTransaction === false) {
        const { postTransaction } = useWorkflow();
        return await postTransaction(transaction);
    }

    return transaction;
};

const removeItem = async (data, existingTransaction = false) => {
    let transaction = existingTransaction || [];

    data.list.item = data.list.item.filter((item) => item.valueX?.id !== data.id);
    transaction.push(crud.patch(data.list));

    if (existingTransaction === false) {
        const { postTransaction } = useWorkflow();
        return await postTransaction(transaction);
    }

    return transaction;
};

const removeItemFromAllLists = async (data, existingTransaction = false) => {
    let transaction = existingTransaction || [];

    // find all lists where item exists
    const resources = await $httpFhirApi.get('BN_List?type=' + data.type + '&itemReference=' + data.id);
    resources.data.forEach((list) => {
        // remove item from resource list
        list.item = list.item.filter((item) => item.valueX?.id !== data.id) || [];
        transaction.push(crud.patch(list));
    });

    if (existingTransaction === false) {
        const { postTransaction } = useWorkflow();
        return await postTransaction(transaction);
    }

    return transaction;
};

const deleteList = async (data, existingTransaction = false) => {
    let transaction = existingTransaction || [];

    transaction.push(crud.delete({ id: data.id, resourceType: 'BN_List' }));

    if (existingTransaction === false) {
        const { postTransaction } = useWorkflow();
        return await postTransaction(transaction);
    }

    return transaction;
};

const deleteListAndContents = async (data, existingTransaction = false) => {
    let transaction = existingTransaction || [];

    // find all lists where item exists
    const resources = await $httpFhirApi.get('BN_List?_id=' + data.id);
    resources.data[0].item?.forEach((item) => {
        if (!item.valueX?.resourceType || !item.valueX?.id) return;
        // remove the referenced resource
        transaction.push(crud.delete(item.valueX));
    });
    transaction.push(crud.delete({ id: data.id, resourceType: 'BN_List' }));

    if (existingTransaction === false) {
        const { postTransaction } = useWorkflow();
        return await postTransaction(transaction);
    }

    return transaction;
};

const saveList = async (data, existingTransaction = false) => {
    let transaction = existingTransaction || [];

    const lists = Array.isArray(data.list) ? data.list : [data.list];
    lists.forEach((list) => {
        if (list.temp.isNew || !list.id) {
            transaction.push(crud.post(list));
        } else {
            transaction.push(crud.patch(list));
        }
    });

    if (existingTransaction === false) {
        const { postTransaction } = useWorkflow();
        return await postTransaction(transaction);
    }

    return transaction;
};

export function useListFlow() {
    return { addItem, removeItem, removeItemFromAllLists, deleteList, deleteListAndContents, saveList };
}
